import React from 'react';
import ReactDOM from 'react-dom/client';
import { SuperTokensWrapper } from 'supertokens-auth-react';
import App from './App';

// Bootstrap CSS
import "bootstrap/dist/css/bootstrap.min.css";
// Bootstrap Bundle JS
import "bootstrap/dist/js/bootstrap.bundle.min";
// CSS Override
import './css/override.css';

const root = ReactDOM.createRoot(document.getElementById('root')); // Strict mode has now been removed. Now we know this source works as intended, we no longer reply on double calls.
root.render(
    <SuperTokensWrapper>
      <App/>
    </SuperTokensWrapper>
);